var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-stepper-header',[_vm._l((_vm.steps),function(step,index){return [_c('StepSummaryItem',{key:("step-" + index),class:{
                'pl-4': index === 0,
                'pr-4': index === _vm.steps.length - 1
            },attrs:{"currentStep":_vm.currentStep,"stepId":(index + 1),"step":step}}),_vm._v(" "),(index < _vm.steps.length - 1)?_c('v-divider',{key:index}):_vm._e()]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cabefee","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/myHabiteoStudio/components/StepSummaryItems.vue
// module id = null
// module chunks = 